import { ROUTES } from '~/routes-typed'
import { CategoryIcon } from '~/theme/icons'

import {
  CalendarIcon,
  CustomerIcon,
  CustomSupport,
  ErpSoftwareIcon,
  GoogleIcon,
  PageBuilderIcon,
  PhoneIcon,
  type DuoColorIconProps,
} from './icons'

const defaultInactiveFeatureDescription =
  'Jetzt neue Funktion freischalten! Melde dich bei deinem joviva Partnermanager.'

export enum JovivaService {
  CALENDAR = 'CALENDAR',
  GOOGLE_BUSINESS = 'GOOGLE_BUSINESS',
  ERP = 'ERP',
  CONTRACT_MANAGEMENT = 'CONTRACT_MANAGEMENT',
  ARTICLE_INVENTORY = 'ARTICLE_INVENTORY',
  PHONE = 'PHONE',
  CUSTOMER = 'CUSTOMER',
  PAGE_BUILDER = 'PAGE_BUILDER',
}

export const JOVIVA_SERVICES = [
  JovivaService.CALENDAR,
  JovivaService.GOOGLE_BUSINESS,
  JovivaService.ERP,
  JovivaService.CONTRACT_MANAGEMENT,
  JovivaService.PAGE_BUILDER,
  JovivaService.ARTICLE_INVENTORY,
  JovivaService.PHONE,
  JovivaService.CUSTOMER,
] as const
export type JovivaServiceKey = (typeof JOVIVA_SERVICES)[number]

export const JOVIVA_SERVICE_TITLES: Record<JovivaServiceKey, string> = {
  CALENDAR: 'Terminverwaltung',
  GOOGLE_BUSINESS: 'Google-Unternehmensprofil',
  ERP: 'Branchensoftware',
  CONTRACT_MANAGEMENT: 'Krankenkassen-Vertragschat',
  PHONE: 'KI-Telefonie',
  CUSTOMER: 'Kundenverwaltung',
  PAGE_BUILDER: 'Webseite erstellen',
  ARTICLE_INVENTORY: 'Artikelstamm',
}

export const JOVIVA_SERVICE_DESCRIPTIONS: Record<JovivaServiceKey, string> = {
  CALENDAR:
    'Verwalte deine Kundentermine und dein Online-Angebot auf joviva.de',
  GOOGLE_BUSINESS: 'Verbinde dein Google-Unternehmensprofil mit joviva',
  ERP: 'Verbinde deine Branchensoftware mit joviva',
  CONTRACT_MANAGEMENT:
    'Stelle Fragen zu deinen Krankenkassen-Verträgen mit joviva',
  PHONE: 'Automatisiere deine eingehenden Anrufe mit KI-Unterstützung',
  CUSTOMER: '',
  PAGE_BUILDER: 'Gestalte selbst deinen Auftritt auf joviva.de',
  ARTICLE_INVENTORY: 'Durchsuche den Sani-Aktuell-Artikel-Katalog',
}

export const JOVIVA_SERVICE_INACTIVE_DESCRIPTIONS: Record<
  JovivaServiceKey,
  string
> = {
  CALENDAR: 'Demnächst verfügbar',
  GOOGLE_BUSINESS: 'Demnächst verfügbar',
  ERP: 'Demnächst verfügbar',
  CONTRACT_MANAGEMENT: defaultInactiveFeatureDescription,
  PHONE: defaultInactiveFeatureDescription,
  CUSTOMER: 'Demnächst verfügbar',
  PAGE_BUILDER: defaultInactiveFeatureDescription,
  ARTICLE_INVENTORY: defaultInactiveFeatureDescription,
}

export const JOVIVA_SERVICE_ICONS: Record<
  JovivaServiceKey,
  React.FC<DuoColorIconProps>
> = {
  CALENDAR: CalendarIcon,
  GOOGLE_BUSINESS: GoogleIcon,
  ERP: ErpSoftwareIcon,
  PAGE_BUILDER: PageBuilderIcon,
  CONTRACT_MANAGEMENT: CustomSupport,
  PHONE: PhoneIcon,
  CUSTOMER: CustomerIcon,
  ARTICLE_INVENTORY: CategoryIcon,
}

export const JOVIVA_SERVICE_URLS: Record<JovivaServiceKey, string | undefined> =
  {
    CALENDAR: ROUTES.CHOOSE_STORE.$buildPath({}),
    GOOGLE_BUSINESS: ROUTES.GOOGLE_BUSINESS_REDIRECT.$buildPath({}),
    ERP: ROUTES.ERP_REDIRECT.$buildPath({}),
    CONTRACT_MANAGEMENT: ROUTES.CONTRACT_MANAGEMENT.$buildPath({}),
    PHONE: 'https://app.telefonassistent.de',
    CUSTOMER: undefined,
    PAGE_BUILDER: ROUTES.PAGE_BUILDER.$buildPath({}),
    ARTICLE_INVENTORY: ROUTES.INVENTORY.$buildPath({}),
  }
